import { styled } from "@linaria/react";
import { Panel, PanelHeading } from "@/styles/utils/StyledPanel";
import { breakpoints, colors, typography } from "@/styles/utils/vars";
import { ButtonBase, ButtonGroup } from "@/ui/Button/StyledButton";
import { cssIcon } from "@/ui/Icon";
import { StyledSelectInputWrapper } from "@/ui/Select/StyledSelect";
import { TypographyBase } from "@/ui/Typography/Typography";
export const SigninSocialsContainer = /*#__PURE__*/styled('div')({
  name: "SigninSocialsContainer",
  class: "SigninSocialsContainer_sx4v1tj"
});
export const StyledForm = /*#__PURE__*/styled('form')({
  name: "StyledForm",
  class: "StyledForm_s1ir8ri0"
});
export const StyledFormWrapper = /*#__PURE__*/styled('div')({
  name: "StyledFormWrapper",
  class: "StyledFormWrapper_sl4q98z"
});
export const FormPanel = /*#__PURE__*/styled(Panel)({
  name: "FormPanel",
  class: "FormPanel_f1oo43pg"
});
export const FormGroup = /*#__PURE__*/styled('div')({
  name: "FormGroup",
  class: "FormGroup_frfemne"
});

require("./StyledForms.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledForms.tsx");